var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.25H5C4.5875 14.25 4.25 13.9125 4.25 13.5V4.5C4.25 4.0875 4.5875 3.75 5 3.75H8.75C9.1625 3.75 9.5 3.4125 9.5 3C9.5 2.5875 9.1625 2.25 8.75 2.25H4.25C3.4175 2.25 2.75 2.925 2.75 3.75V14.25C2.75 15.075 3.425 15.75 4.25 15.75H14.75C15.575 15.75 16.25 15.075 16.25 14.25V9.75C16.25 9.3375 15.9125 9 15.5 9C15.0875 9 14.75 9.3375 14.75 9.75V13.5C14.75 13.9125 14.4125 14.25 14 14.25ZM11 3C11 3.4125 11.3375 3.75 11.75 3.75H13.6925L6.845 10.5975C6.5525 10.89 6.5525 11.3625 6.845 11.655C7.1375 11.9475 7.61 11.9475 7.9025 11.655L14.75 4.8075V6.75C14.75 7.1625 15.0875 7.5 15.5 7.5C15.9125 7.5 16.25 7.1625 16.25 6.75V3C16.25 2.5875 15.9125 2.25 15.5 2.25H11.75C11.3375 2.25 11 2.5875 11 3Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.d5873fb4d820c75470a62bd95fec3306.svg";
export { ForwardRef as ReactComponent };